import React from "react";

export const Spacer = ({ height }) => (
  <div
    style={{
      marginBottom: `${height}px`,
    }}
  />
);
